import React__default from 'react';
import { SurveyThemeWrapper } from '@sm/question-ui/theme-respondent';
import { d as declareVisualization, p as providerFactory } from './utils-6da50e2f.js';
import { MultipleChoice, CheckBox, ImageChoice } from '@sm/question-ui/respondent-quiz-results';
export { S as SingleQuestionController } from './controllers-bba08bca.js';
import './vendor-4c16529b.js';
import '@sm/question-ui/helpers';
import '@sm/question-definitions';
/**
 * Derive the answer layout columns
 * @param answerLayout answer layout from external question
 */

const getAnswerLayoutColumns = answerLayout => {
  if (answerLayout === 'VERTICAL') {
    return 1;
  }

  if (answerLayout === 'TWO_COLUMNS') {
    return 2;
  }

  if (answerLayout === 'THREE_COLUMNS') {
    return 3;
  }

  return 'horizontal';
};

const isAnswer = maybeAnswer => 'label' in maybeAnswer && 'id' in maybeAnswer && 'visible' in maybeAnswer;

const quizAnswersToImageAnswers = (quizAnswers, answersImage) => quizAnswers.map(ans => {
  if (!isAnswer(ans.answer)) {
    return ans;
  }

  const matchingImageAnswer = answersImage.find(ansImg => ansImg.id === ans.answer.id);

  if (!matchingImageAnswer) {
    throw new Error('Image not found'); // TODO: Handle this later
  }

  const answer = matchingImageAnswer;
  return { ...ans,
    answer: { ...answer
    }
  };
});
/**
 * Map the quiz results with the image answers
 * @param quizResults the quizResults provided by the external question
 * @param answersImage the answersImage provided by the external question
 */


const getQuizResultsWithImage = (quizResults, answersImage) => ({ ...quizResults,
  answers: quizAnswersToImageAnswers(quizResults.answers, answersImage)
});

const MultipleChoiceVisualization = ({
  question: {
    layout: {
      answerLayout,
      spacing
    },
    quizResults,
    id,
    title,
    questionNumber,
    answerNoneOfTheAbove,
    answerOther
  },
  settings: {
    survey: {
      numberingEnabled,
      highlightCorrectAnswers
    }
  }
}) => {
  // TODO: use a better error handling once we have the error handing
  // pattern designed
  if (!quizResults) {
    /* eslint-disable-next-line no-console */
    console.warn('Missing quiz results in the data');
    return React__default.createElement(React__default.Fragment, null);
  }

  const answerLayoutColumns = getAnswerLayoutColumns(answerLayout);
  return React__default.createElement(MultipleChoice, {
    id: id,
    title: title,
    questionNumber: questionNumber,
    highlightCorrectAnswers: highlightCorrectAnswers,
    numberingEnabled: numberingEnabled,
    answerNoneOfTheAbove: answerNoneOfTheAbove,
    answerLayoutColumns: answerLayoutColumns,
    spacing: spacing,
    answerOther: answerOther,
    quizResults: quizResults
  });
};

var MultipleChoiceVisualization$1 = declareVisualization(['multiple_choice'], ['respondent-quiz-results'], MultipleChoiceVisualization);

const CheckBoxVisualization = ({
  question: {
    layout: {
      answerLayout,
      spacing
    },
    quizResults,
    id,
    title,
    questionNumber,
    answerNoneOfTheAbove,
    answerOther
  },
  settings: {
    survey: {
      numberingEnabled,
      highlightCorrectAnswers
    }
  }
}) => {
  // TODO: use a better error handling once we have the error handing
  // pattern designed
  if (!quizResults) {
    /* eslint-disable-next-line no-console */
    console.warn('Missing quiz results in the data');
    return null;
  }

  const answerLayoutColumns = getAnswerLayoutColumns(answerLayout);
  return React__default.createElement(CheckBox, {
    id: id,
    title: title,
    questionNumber: questionNumber,
    highlightCorrectAnswers: highlightCorrectAnswers,
    numberingEnabled: numberingEnabled,
    answerNoneOfTheAbove: answerNoneOfTheAbove,
    answerLayoutColumns: answerLayoutColumns,
    spacing: spacing,
    answerOther: answerOther,
    quizResults: quizResults
  });
};

var CheckBoxVisualization$1 = declareVisualization(['check_box'], ['respondent-quiz-results'], CheckBoxVisualization);

const ImageChoiceVisualization = ({
  question: {
    quizResults,
    id,
    title,
    questionNumber,
    answerNoneOfTheAbove,
    answersImage,
    variant
  },
  settings: {
    survey: {
      numberingEnabled,
      highlightCorrectAnswers
    }
  }
}) => {
  // TODO: use a better error handling once we have the error handing
  // pattern designed
  if (!quizResults) {
    /* eslint-disable-next-line no-console */
    console.warn('Missing quiz results in the data');
    return React__default.createElement(React__default.Fragment, null);
  }

  const isManyAnswers = variant === 'MANY_ANSWERS_IMAGE';
  const quizResultsWithImage = getQuizResultsWithImage(quizResults, answersImage);
  return React__default.createElement(ImageChoice, {
    id: id,
    title: title,
    questionNumber: questionNumber,
    highlightCorrectAnswers: highlightCorrectAnswers,
    numberingEnabled: numberingEnabled,
    answerNoneOfTheAbove: answerNoneOfTheAbove || null,
    quizResults: quizResultsWithImage,
    isManyAnswers: isManyAnswers
  });
};

var ImageChoiceVisualization$1 = declareVisualization(['image_choice'], ['respondent-quiz-results'], ImageChoiceVisualization);

const DropdownVisualization = ({
  question: {
    layout: {
      answerLayout,
      spacing
    },
    quizResults,
    id,
    title,
    questionNumber,
    answerOther
  },
  settings: {
    survey: {
      numberingEnabled,
      highlightCorrectAnswers
    }
  }
}) => {
  // TODO: use a better error handling once we have the error handing
  // pattern designed
  if (!quizResults) {
    /* eslint-disable-next-line no-console */
    console.warn('Missing quiz results in the data');
    return React__default.createElement(React__default.Fragment, null);
  }

  const answerLayoutColumns = getAnswerLayoutColumns(answerLayout);
  return React__default.createElement(MultipleChoice, {
    id: id,
    title: title,
    questionNumber: questionNumber,
    highlightCorrectAnswers: highlightCorrectAnswers,
    numberingEnabled: numberingEnabled,
    answerNoneOfTheAbove: null,
    answerLayoutColumns: answerLayoutColumns,
    spacing: spacing,
    answerOther: answerOther,
    quizResults: quizResults
  });
};

var DropdownVisualization$1 = declareVisualization(['dropdown'], ['respondent-quiz-results'], DropdownVisualization);
var visualizationList = [MultipleChoiceVisualization$1, CheckBoxVisualization$1, ImageChoiceVisualization$1, DropdownVisualization$1];
const ProviderHelper = providerFactory(visualizationList);

const QuizResultsCapabilityProvider = ({
  settings,
  children
}) => {
  return React__default.createElement(ProviderHelper, {
    value: {
      capability: 'respondent-quiz-results',
      upstreamActions: null,
      renderProps: null,
      settings
    }
  }, React__default.createElement(SurveyThemeWrapper, null, children));
};

export { QuizResultsCapabilityProvider, visualizationList as QuizResultsVisualizationList };